export type Alternative =
  | "existing"
  | "NB_Only"
  | "SB_Only"
  | "Converging_Diverging"
  | "Converging_Diverging_Short";

export type AlternativeWithoutExisting = Exclude<Alternative, "existing">;

export const ALL_ALTERNATIVES: Alternative[] = [
  "existing",
  "NB_Only",
  "SB_Only",
  "Converging_Diverging",
  "Converging_Diverging_Short",
];
